<template>
    <div class="FM_withdrawalInfo">
        <!-- 添加处罚信息 -->
        <el-dialog
            ref="terminalAudit"
            :visible="detailIsShow"
            @close="handleClose"
            :close-on-click-modal="false"
        >
			<el-card class="box-card" shadow="hover">
                <div class="purseTitle">
                    <div>扣款信息</div>
                </div>
                <el-row class="rowTitle">
                    <el-col :sm="12" :md="12" :lg="8">
                        <span class="labels">备注：</span>
                        <span v-html='dialogData.data.content'></span>
                    </el-col>
                </el-row>
                <div class="purseTitle">
                    <div>扣款详情</div>
                </div>
                <el-table
                    :data="dialogData.data.profit_list"
                    size="mini"
                    height="200"
                    border
                    style="width: 100%"
                >
                    <!-- id -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="序号"
                        min-width="80"
                    ></el-table-column>
                    <!-- 代理名称 -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="nickname"
                        label="代理名称"	
                        min-width="100"
                    ></el-table-column>
                    <!-- 政策 -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="amount"
                        label="扣款金额"
                        min-width="80"
                    ></el-table-column>
					<!-- 政策 -->
					<el-table-column
					    header-align="center"
					    align="center"
					    prop="account_type_text"
					    label="扣款账户"
					    min-width="80"
					></el-table-column>
                    <!-- 分润 -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="create_time"
                        label="扣款时间"
                        min-width="120"
                    ></el-table-column>
                </el-table>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "FM_details",
    props: {
        detailIsShow: {
            type: Boolean,
            default: false
        },
        dialogData: {
            type: Object
        },
    },
	data() {
	    return {
	        InfoTable: [], //表格
	    }
	},
    methods: {
        handleClose(ref) {
            this.$emit('infoClose', ref);
        },
		formatStatus(row) { //格式化当前状态
		    var status = '';
		    switch (row.account_type) {
		        case 1:
		            status = '活动账户';
		            break;
		
		        case 2:
		            status = '押金账户';
		            break;
		        default:
		            status = '分润账户';
		            break;
		    }
		    return status;
		},
    },
};
</script>

<style lang="scss" scope>
.FM_withdrawalInfo {
	.purseTitle {
	    font-size: 12px;
	    margin: 10px 0;
	    color: #909399;
	    :nth-child(1) {
	        font-weight: 700;
	        color: #7f7f7f;
	        padding-left: 10px;
	        border-left: 4px solid #909399;
	    }
	}
	.rowTitle {
	    color: #909399;
	    font-size: 12px;
	    .el-col {
	        margin: 5px 0;
	    }
	    .labels {
	        font-weight: 700;
	    }
	}
    * {
        font-size: 12px;
    }
    .labels {
        font-weight: 700;
    }
    .desc {
        border: 1px solid #d0d0d0;
        background-color: #ebeef5;
        padding: 3px;
        line-height: 20px;
        margin-top: 5px;
    }
    .title {
        margin: 10px 0;
        font-size: 13px;
        font-weight: 700;
        border-left: 5px solid #40b8ff;
        padding: 0 0 0 10px;
        .el-button--text {
            color: #303133;
            font-size: 13px;
            font-weight: 700;
        }
    }
    .el-input__inner,
    .el-row {
        margin: 10px 0;
        &:last-child {
            margin-bottom: 0;
        }
        .el-col {
            margin: 10px 0;
        }
    }
}
img{
	    max-width: 450px;
		  max-height: 300px;
    }
</style>
